import {
  GET_CATEGORY_FEATURES_ERROR,
  GET_CATEGORY_FEATURES_START,
  GET_CATEGORY_FEATURES_SUCCESS,
} from 'constants/action-types/settings/getCategoryFeatures';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_CATEGORY_FEATURES_START:
      return {
        ...state,
        categoryFeatures: {
          loading: true,
          error: null,
          data: [],
          meta: {},
        },
      };
    case GET_CATEGORY_FEATURES_ERROR:
      return {
        ...state,
        categoryFeatures: {
          ...state.categoryFeatures,
          error: payload,
          loading: false,
        },
      };
    case GET_CATEGORY_FEATURES_SUCCESS:
      return {
        ...state,
        categoryFeatures: {
          ...state.categoryFeatures,
          data: payload.data,
          meta: payload.meta,
          loading: false,
        },
      };
    default:
      return null;
  }
};
